/**
 * Maps variant printing/condition labels to Inventory CSS module keys.
 * Uses shared normalization from variantLabeling; logic is UI-specific (chip colors).
 */
import { normalizePrintingLabel, normalizeVariantToken } from './variantLabeling'

export type InventoryConditionClassKey =
  | 'conditionNeutral'
  | 'conditionSealed'
  | 'conditionDamaged'
  | 'conditionHeavilyPlayed'
  | 'conditionModeratelyPlayed'
  | 'conditionLightlyPlayed'
  | 'conditionNearMint'

export type InventoryPrintingClassKey =
  | 'printingNeutral'
  | 'printingReverseHolofoil'
  | 'printingNormal'
  | 'printingEtched'
  | 'printingFirstEdition'
  | 'printingUnlimited'
  | 'printingHolofoil'

export function getConditionClassName(condition?: string | null): InventoryConditionClassKey {
  const normalized = normalizeVariantToken(condition)

  if (!normalized) return 'conditionNeutral'
  if (normalized === 'sealed' || normalized.includes('factory sealed')) return 'conditionSealed'
  if (normalized === 'damaged' || normalized === 'dmg' || normalized.includes('poor')) return 'conditionDamaged'
  if (normalized === 'hp' || normalized.includes('heavily played') || normalized.includes('heavy play')) return 'conditionHeavilyPlayed'
  if (normalized === 'mp' || normalized.includes('moderately played') || normalized.includes('moderate play')) return 'conditionModeratelyPlayed'
  if (normalized === 'lp' || normalized.includes('lightly played') || normalized.includes('light play') || normalized === 'excellent')
    return 'conditionLightlyPlayed'
  if (normalized === 'nm' || normalized === 'mint' || normalized === 'm' || normalized.includes('near mint') || normalized.includes('gem mint'))
    return 'conditionNearMint'

  return 'conditionNeutral'
}

export function getPrintingClassName(printing?: string | null): InventoryPrintingClassKey {
  const normalized = normalizeVariantToken(normalizePrintingLabel(printing))

  if (!normalized) return 'printingNeutral'
  if (normalized.includes('reverse holo') || normalized.includes('holo reverse')) return 'printingReverseHolofoil'
  if (normalized.includes('non holo') || normalized.includes('non-holo') || normalized === 'normal' || normalized.includes('standard'))
    return 'printingNormal'
  if (normalized.includes('etched')) return 'printingEtched'
  if (normalized.includes('1st edition') || normalized.includes('1st ed') || normalized.includes('first edition')) return 'printingFirstEdition'
  if (normalized.includes('unlimited')) return 'printingUnlimited'
  if (normalized.includes('holofoil') || normalized.includes('holo') || normalized.includes('foil')) return 'printingHolofoil'

  return 'printingNeutral'
}
